<template>
  <LayoutModalComponent
    :parentRoute="{ name: 'publications' }"
    :class="$style.root"
  >
    <LayoutCollectionTypeHeadingComponent
      :pageData="pageData"
      :parentPageData="parentPageData"
      :injectClose="false"
    />

    <div :class="$style.thumbnail">
      <SharedThumbnailPublicationComponent
        :data="pageData"
        elementType="div"
      />
    </div>

    <CoreBlocksComponent
      :class="$style.blocks"
      v-if="blocks?.length"
      :blocks="blocks"
    />
  </LayoutModalComponent>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  parentPageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const blocks = computed(() => {
  return localizedData?.value?.blocks
})
</script>

<style module>
.root {}

.thumbnail {
  composes: container--small from global;
  margin-top: var(--unit--vertical--tripple);
  display: flex;
  justify-content: center;

  --width--publication-thumbnail: 75%;
}

.blocks {
}

.root:has(.blocks) .thumbnail {
  margin-bottom: var(--unit--vertical--tripple);
}
</style>
